import React, { Component } from 'react'
import './about.scss';
import Header from '../Header/Header';
import Links from '../Links/Links';
import CapOne from '../../img/1635782717682.png';
import Streamforge from '../../img/Streamforge.png';
import Leidos from '../../img/Leidos.png';
import Me from '../../img/me.png';


class About extends Component {
    render() {
        return (
          <div>
          <main class="About">
            <Header />
            <section class="container-lg">
              <div class="AboutMe">
                <div class = "PicContainer">
                  <img src={Me} alt="" class = "MyPic"/>
                </div>
                <div>
                  <h3 class="text">Hi! I'm Jeff.</h3>
                  <p class="text"> 
                    I'm a recent Computer Science graduate from Boston University and am back in the Bay Area after a brief hiatus in Taipei!
                  </p>
                  <p class="text">
                    I love building out innovative solutions in the design, productivity, and finanical sectors, and have experience conceptualizing and delivering end-to-end projects in these respective areas.
                  </p>
                  <p class="text">
                    I take pride in my amicable spirit, which, like Steph Curry and his incredible hand eye coordination, I use to tackle any array of challenges on and off the court (a.k.a. my computer monitor).
                  </p>
                  <p class="text">
                    In my free time I enjoy building the latest and greatest LEGO sets, following the Warriors, and relentlessly searching for the best matcha latte the Bay Area has to offer!
                  </p>
                </div>
              </div>
            </section>
            <section class="MyExperience uppercase">
              <div class="container-lg">
                <div>
                  <h3 class="experiences-header">Experiences</h3>
                </div>
              </div>
              <div class="container-lg">
                <div class="product-card product-card--has-subdescription">
                  <div class="company-logo"> 
                    <img src={CapOne} alt="CapOne" />
                  </div>
                  <div class="product-card-content">
                    <h3 class="internship-title">Capital One</h3>
                    <p class="internship-desc">Software Engineering Intern, EMI Core Platform</p>
                  </div>
                </div>
                <div class="product-card product-card--has-subdescription">
                  <div class="company-logo"> 
                    <img src={Leidos} alt="Leidos" />
                  </div>
                  <div class="product-card-content">
                    <h3 class="internship-title">Leidos</h3>
                    <p class="internship-desc">Software Development Intern, VeRTUe</p>
                  </div>
                </div>
                <div class="product-card product-card--has-subdescription">
                  <div class="company-logo"> 
                    <img src={Streamforge} alt="Streamforge" />
                  </div>
                  <div class="product-card-content">
                    <h3 class="internship-title">Streamforge</h3>
                    <p class="internship-desc">Software Engineering Intern</p>
                  </div>
                </div>
            </div>
            </section>
            <Links/>
          </main>
          <script src="../../js/fade.js"></script>
          </div>
        )
    }
}

export default About